import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SeeTheDifferenceBeforeAfterCleaning() {
  const comparisons = [{
    id: 1,
    title: "Flächenreinigung",
    before: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/surface_cleaning_before.png",
    after: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/surface_cleaning_after.png"
  }, {
    id: 2,
    title: "Hausmeisterservice",
    before: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/facility_maintenance_before.png",
    after: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/facility_maintenance_after.png"
  }, {
    id: 3,
    title: "Gartenpflege",
    before: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/garden_maintenance_before.png",
    after: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/garden_maintenance_after.png"
  }, {
    id: 4,
    title: "Büroorganisation",
    before: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/office_organization_before.png",
    after: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/office_organization_after.png"
  }];
  return <section className="py-16 md:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-foreground mb-12 animate-fade-in-up">
          Unsere Leistungsbereiche: Vorher & Nachher
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {comparisons.map((item, i) => <div key={item.id} data-index={i} className="bg-muted-light border border-border rounded-lg shadow-soft overflow-hidden hover:-translate-y-1 hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] animate-fade-in-up" style={{
          animationDelay: `${i * 100}ms`
        }}>
              <h3 className="text-xl font-semibold text-foreground text-center py-4 border-b border-border">
                {item.title}
              </h3>

              <div className="grid grid-cols-2 divide-x divide-border">
                <div className="relative aspect-square">
                  <img src={item.before} alt={`${item.title} vor der Bearbeitung`} className="w-full h-full object-cover" />
                  <div className="absolute bottom-0 left-0 right-0 bg-accent/80 text-accent-foreground text-sm font-medium py-2 text-center">
                    Vorher
                  </div>
                </div>

                <div className="relative aspect-square">
                  <img src={item.after} alt={`${item.title} nach der Bearbeitung`} className="w-full h-full object-cover" />
                  <div className="absolute bottom-0 left-0 right-0 bg-primary/80 text-primary-foreground text-sm font-medium py-2 text-center">
                    Nachher
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center animate-fade-in-up" style={{
        animationDelay: "400ms"
      }}>
          <p className="text-muted-foreground mb-6 max-w-2xl mx-auto leading-relaxed">
            Münsterland Industrieservice UG bietet professionelle Dienstleistungen in vier Kernbereichen: 
            Flächenreinigung ohne Chemie, Hausmeistertätigkeiten, Gartenpflege sowie Büroorganisation. 
            Jeder Bereich wird mit höchster Sorgfalt und Professionalität ausgeführt.
          </p>
          <Link to="/KontaktPage">
            <Button className="btn-primary">
              Kostenloses Angebot anfordern
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}